module.exports = __webpack_public_path__ + "static/media/retirada-yellow-icon.7cc959b3.svg";